<mat-form-field style="margin:0!important">
    <input type="text" style="height:200%" matInput placeholder="Digita l'ID o la targa" (keydown.enter)="searchByVal()"
        [(ngModel)]="searchVal">
    <button class="btn btn-success" type="button" matSuffix mat-icon-button (click)="searchByVal()">
        <i class="material-icons"> search </i>
    </button>
</mat-form-field>